module.exports = __webpack_public_path__ + "static/Stellenplan im Excel-c8c43eb6a257427caf5107db764d01e7.jpg";